import { withInstall } from '@tav-ui/utils/with-install'
import IconSvg from './src/icon-svg.vue'
const TaIconSvg = withInstall(IconSvg)
export { TaIconSvg }
export default TaIconSvg
